exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* .el-crud-form .el-form-item {\n\tmargin-bottom: 0;\n} */\n.el-form-item__label {\n    line-height: inherit;\n}\n.el-form-item__content {\n    line-height: inherit;\n}\n.el-button--mini {\n\tpadding: 7px;\n}\n", ""]);

// exports
